import React from "react";
import { MERGE_TAG_KEYS } from "../domain/merge-tags";
import { selectEmailSettings } from "../domain/selectors";
import { useEditorStore } from "../domain/store";
import type { EyebrowBlock } from "../domain/types";
import { EmailBuilderRichTextEditor } from "../editing/richText/EmailBuilderRichTextEditor";
import { eyebrowTextStyle } from "../render/blocks/eyebrow";

type InlineEyebrowLabelProps = {
  block: EyebrowBlock;
};

export function InlineEyebrowLabel({
  block,
}: InlineEyebrowLabelProps) {
  const textTheme = useEditorStore(selectEmailSettings);

  return (
    <EmailBuilderRichTextEditor
      blockId={block.id}
      kind="label"
      content={block.text}
      fontWeight={block.fontWeight}
      editorClassName="email-builder-inline-button-label"
      editorStyle={eyebrowTextStyle(block, textTheme)}
      ariaLabel={block.text}
      placeholder=""
      mergeTags={MERGE_TAG_KEYS}
      contentAttribute="data-email-builder-inline-button-label"
    />
  );
}
